import { AfterViewInit, Component, Input, ViewEncapsulation } from '@angular/core';
import { ClassNames } from '../../../constants/class-names.constants';
import { IMobileBannerTab, MobileBannerTabsConfig } from '../../../models/common';
import { Utilities } from '../../../utilities/utilities.helper';

@Component({
    selector: 'lsq-mobile-banner-tabs',
    template: `
        <div class="mobile-banner-tabs" *ngIf="config?.tabs?.length > 0">
            <div
                [ngClass]="bindTabClass(tab)"
                *ngFor="let tab of config?.tabs"
                (click)="selectTab(tab)"
            >
                <span>{{ tab.label }}</span>
            </div>
        </div>

        <div *ngIf="config?.tabs?.length > 0 && config?.activeTab?.templateRef">
            <ng-container *ngTemplateOutlet="config.activeTab.templateRef"></ng-container>
        </div>
    `,
    styleUrls: ['./lsq-mobile-banner-tabs.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LsqMobileBannerTabsComponent implements AfterViewInit {
    @Input() public config: MobileBannerTabsConfig;

    public ngAfterViewInit(): void {
        Utilities.executeAfterRender(() => {
            this.selectTab();
        });
    }

    public bindTabClass(tab: IMobileBannerTab): string[] {
        const classNames = [ClassNames.MobileBannerTab];
        if (tab.isActive) {
            classNames.push(ClassNames.Active);
        }
        return classNames;
    }

    public selectTab(bannerTab?: IMobileBannerTab): void {
        const tabIndex = bannerTab ? this.config.tabs.indexOf(bannerTab) : 0;
        this.config.tabs.forEach((tab, index) => {
            tab.isActive = false;
            if (tabIndex === index) {
                tab.isActive = true;
                this.config.activeTab = tab;
            }
        });
    }
}
